import { Component, OnInit, inject } from '@angular/core';
import { NgClass } from '@angular/common';

import { ApContentService, ApContentComponent, ApContentPipe } from '@ap/content';
import { ApButtonComponent } from '@ap/button';

import { ConsentLevels } from './cookie-consent.model';
import { CALLBACK_FNC, CONSENT_DATA, LAYOUT_DATA } from './cookie-consent.tokens';
import content from './cookie-consent.content.json';

/**
 * @ngdoc component
 * @name ApCookieConsentComponent
 *
 * @param {string=} [layout] The layout strategy to use.
 * Can be either empty or small (to match the application canvas-small layout)
 */
@Component({
    selector: 'ap-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.scss'],
    imports: [NgClass, ApContentComponent, ApButtonComponent, ApContentPipe]
})
export class ApCookieConsentComponent implements OnInit {
    consentLevels = inject<ConsentLevels>(CONSENT_DATA);
    layout = inject(LAYOUT_DATA);
    callback = inject(CALLBACK_FNC);
    private readonly contentService = inject(ApContentService);

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public acceptCookies(accept: boolean): void {
        this.consentLevels.advertisements = accept;
        this.consentLevels.personalisation = accept;
        this.callback(this.consentLevels);
    }
}
